export interface SlideKeyFact {
  label: string;
  content: string;
}

export interface SlideItem {
  title: string;
  body?: string;
  bullets?: string[];
  keyFact?: SlideKeyFact;
}

export interface SlidesData {
  title: string;
  slides: SlideItem[];
}

export function parseSlidesBlock(jsonStr: string): SlidesData | null {
  try {
    const raw = JSON.parse(jsonStr);
    if (!raw || typeof raw.title !== "string" || !Array.isArray(raw.slides)) {
      return null;
    }

    const slides: SlideItem[] = raw.slides
      .filter((s: any) => s && typeof s.title === "string")
      .map((s: any) => {
        const item: SlideItem = { title: String(s.title) };
        if (typeof s.body === "string") item.body = s.body;
        if (Array.isArray(s.bullets)) {
          item.bullets = s.bullets
            .filter((b: any) => typeof b === "string")
            .slice(0, 6);
        }
        if (
          s.keyFact &&
          typeof s.keyFact.label === "string" &&
          typeof s.keyFact.content === "string"
        ) {
          item.keyFact = { label: s.keyFact.label, content: s.keyFact.content };
        }
        return item;
      });

    if (slides.length === 0) return null;

    return { title: raw.title, slides };
  } catch {
    return null;
  }
}
